import { ResultsCountAndSeeMore } from "components/ResultsCountAndSeeMore";
import { SchoolSearchCard } from "components/schools/SchoolSearchCard/SchoolSearchCard";
import { isProduction } from "scripts/application/setting";
import {
  ISchoolSearchArtifact,
  ISchoolSearchItem,
} from "types/artifacts/search-schools";
import { IArtifactComponentProps } from "types/services";

export interface ISearchSchoolsOutputParams {
  search_id?: string;
  school_id?: string;
}

export type ISearchSchoolsOutputProps = IArtifactComponentProps<
  ISearchSchoolsOutputParams,
  ISchoolSearchArtifact
>;

SearchSchoolsListOutput.artifactKey = "search_schools";

export function SearchSchoolsListOutput(
  props: ISearchSchoolsOutputProps
): JSX.Element {
  const { search_id, school_id, artifacts } = props;

  // if there is no valid artifacts return from the backend
  if (!Array.isArray(artifacts)) return <></>;

  if (school_id) {
    const school = artifacts
      .map((artifact) => {
        const schools =
          (artifact?.response?.schools as unknown as ISchoolSearchItem[]) || [];
        return schools.find((s) => s.school_id === school_id);
      })
      .find(Boolean);

    if (school) {
      return <SchoolSearchCard {...school} maxWidth={300} />;
    }

    console.error(
      "No artifact or school found for 'SearchSchoolsListOutput' with the given school_id:",
      school_id
    );

    return <></>;
  }

  if (search_id) {
    const artifact = artifacts.find((x) => x.id === search_id);
    const schoolsCount = artifact?.schools?.length || 0;

    if (artifact && schoolsCount > 0) {
      const seeMore = () => {
        const replacedUrl =
          artifact?.response?.url.replace("/school?", "") || "";
        return `https://www.har.com/school/search/advance?${replacedUrl}`;
      };
      return (
        <>
          <SchoolSearchCard.Carousel
            {...artifact}
            schoolsCount={schoolsCount}
          />
          <ResultsCountAndSeeMore
            seeMore={seeMore}
            start={artifact.response.start}
            stop={artifact.response.stop}
            total={artifact.response.total}
          />
        </>
      );
    }

    console.error(
      "No artifact or schools found for 'SearchSchoolsListOutput' with the given search_id:",
      search_id
    );

    return <></>;
  }

  console.error(
    "No search_id or school_id provided for 'SearchSchoolsListOutput'."
  );

  return <></>;
}

SearchSchoolsListOutput.asText = function (props: ISearchSchoolsOutputProps): string {
  // console.log("SearchSchoolsListOutput.asText", props);
  return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.artifact_text || "" : isProduction ? "" : "SearchSchoolsListOutput asText Not Implemented!";
}

